import i18n from '@/i18n'
import Layout from '../../companyAdmin/layout.vue'
import Editor from './editor'
import List from './list'

const basePath = '/v-admin/system-policy-management'

export default {
  path: `${basePath}`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: ['PERM_SYSTEM_POLICY_MANAGEMENT'],
    titleI18nKey: 'admin.company.agreement.ajingaPolicyManagement',
    menu: {
      labelI18nKey: 'admin.company.agreement.ajingaPolicyManagement'
    },
    get title () {
      return i18n.t('admin.company.agreement.ajingaPolicyManagement')
    }
  },
  children: [
    {
      path: `${basePath}`,
      component: List,
      meta: {
        breadcrumb: { hidden: true },
        titleI18nKey: 'admin.company.agreement.ajingaPolicyManagement'
      }
    },
    {
      path: `${basePath}/edit/:policyId`,
      component: Editor,
      meta: {
        isEditMode: true,
        permission: ['PERM_SYSTEM_POLICY_MANAGEMENT'],
        titleI18nKey: 'admin.company.agreement.ajingaPolicyManagement',
        menu: {
          labelI18nKey: 'admin.company.agreement.label.editAgreementTitle'
        }
      }
    },
    {
      path: `${basePath}/add`,
      component: Editor,
      meta: {
        permission: ['PERM_SYSTEM_POLICY_MANAGEMENT'],
        titleI18nKey: 'admin.company.agreement.ajingaPolicyManagement',
        menu: {
          labelI18nKey: 'admin.company.agreement.label.createAgreementTitle'
        }
      }
    }
  ]
}
